const styles = (theme) => ({
  root: {
    alignContent: 'flex-end',
    height: '100%',
    width: '100%',
  },
})

export default styles
